import { Avatar, Tooltip } from '@mui/material'

import { CollarColor, CollarCondition } from '#/@types/backend'
import Colors from '#/styles/Colors'

export type CollarConditionType = {
  condition?: {
    status: CollarCondition
    text: string
  }
  color?: {
    status: CollarColor
    text: string
  }
}

const DEFAULT_COLOR = {
  backgroundColor: 'transparent',
  color: 'black',
}

const TypeCollarIdentification = ({ value }: { value?: CollarConditionType | null }) => {
  const { color, condition } = value ?? {}

  if (!condition?.status && !color?.status) return <span>-</span>

  let title = [color?.text, condition?.text].filter(Boolean).join(' - ')

  const letter = condition?.text ? condition.text.charAt(0) : '-'

  const colorStyles = color?.status ? Colors.devices.capsule[color.status] : DEFAULT_COLOR

  return (
    <Tooltip title={title}>
      <Avatar sx={{ ...colorStyles, fontSize: 14, height: 30, width: 30 }}>{letter}</Avatar>
    </Tooltip>
  )
}

export { TypeCollarIdentification }
